<template>
  <div
    class="
      tw-flex
      tw-flex-col
      tw-items-center
      tw-justify-center
      tw-gap-6
      tw-px-10
      tw-text-center
      tw-h-full
    "
    data-testid="assistant-empty-state"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
      <i
        class="
          fa fa-solid fa-wand-magic-sparkles
          tw-text-3xl tw-text-sf-ai-light-1
        "
      />
      <h3 class="tw-my-0 tw-text-base tw-font-bold tw-text-sf-slate-darker-1">
        {{ I18n.t('companies_overview.assistant.empty_state.title') }}
      </h3>
      <p class="tw-m-0 tw-text-sm tw-text-sf-slate-darker-1">
        {{ I18n.t('companies_overview.assistant.empty_state.subtitle') }}
      </p>
    </div>

    <!-- The whole block disappears once loading resolved to no prompts (failure cooldown,
         retired timeout): a SUGGESTIONS header over nothing reads as broken. -->
    <div
      v-if="!suggestionsLoaded || suggestions.length > 0"
      class="tw-flex tw-w-full tw-flex-col tw-gap-3"
    >
      <div
        class="
          tw-text-[10px] tw-font-bold tw-uppercase tw-text-sf-slate-light-2
        "
      >
        {{ I18n.t('companies_overview.assistant.suggestions') }}
      </div>
      <AssistantSuggestionPills
        v-if="suggestionsLoaded"
        :suggestions="suggestions"
        variant="empty"
        @select="$emit('select', $event)"
      />
      <!-- Skeleton until the firm-tailored prompts arrive, by cache hit or by the warm
           job's MessageBus push. There are no static placeholders: a suggestion the firm's
           data cannot answer is worse than no suggestion. -->
      <div
        v-else
        class="tw-flex tw-flex-wrap tw-justify-center tw-gap-1.5"
        aria-hidden="true"
        data-testid="assistant-suggestions-skeleton"
      >
        <div
          v-for="n in EMPTY_STATE_SUGGESTIONS_SHOWN"
          :key="n"
          class="
            tw-h-7
            tw-w-40
            tw-animate-pulse
            tw-rounded-lg
            tw-bg-sf-slate-subtle-2
          "
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import I18n from '@app/adapters/I18n'
import {
  useAssistantStore,
  EMPTY_STATE_SUGGESTIONS_SHOWN,
} from '@app/insights/store/assistant'
import AssistantSuggestionPills from './assistant-suggestion-pills.vue'

const assistantStore = useAssistantStore()
const { emptyStateSuggestions: suggestions, suggestionsLoaded } =
  storeToRefs(assistantStore)

// Load firm-tailored prompts on mount (also advances the backend show counter);
// a skeleton shows until they arrive.
onMounted(() => void assistantStore.fetchEmptyStateSuggestions())

defineEmits<{ (e: 'select', suggestion: string): void }>()
</script>
